import React from "react";
import { useWebTranslation } from "translations";
import {
  Glyph,
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionPanel,
} from "@/ui-kit";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";

const items: Array<{
  icon: Glyph;
  title: string;
  description: string;
}> = [
  {
    icon: "barcode",
    title: "preventive_care.chipping.title",
    description: "preventive_care.chipping.description",
  },
  {
    icon: "syringe",
    title: "preventive_care.vaccines.title",
    description: "preventive_care.vaccines.description",
  },
  {
    icon: "medication",
    title: "preventive_care.antiparasitics.title",
    description: "preventive_care.antiparasitics.description",
  },
  {
    icon: "medical-scalpel",
    title: "preventive_care.castration.title",
    description: "preventive_care.castration.description",
  },
  {
    icon: "health-hands",
    title: "preventive_care.alternative_care.title",
    description: "preventive_care.alternative_care.description",
  },
  {
    icon: "teeth",
    title: "preventive_care.dental_care.title",
    description: "preventive_care.dental_care.description",
  },
  {
    icon: "stethoscope",
    title: "preventive_care.general_health.title",
    description: "preventive_care.general_health.description",
  },
  {
    icon: "vitamins",
    title: "preventive_care.food_supplements.title",
    description: "preventive_care.food_supplements.description",
  },
  {
    icon: "scissors",
    title: "preventive_care.claw_cutting.title",
    description: "preventive_care.claw_cutting.description",
  },
  {
    icon: "bag",
    title: "preventive_care.hygiene.title",
    description: "preventive_care.hygiene.description",
  },
];

export const PopupContent = () => {
  const { t } = useWebTranslation();

  return (
    <Accordion collapsible>
      {items.map(({ title, description, icon }) => {
        return (
          <AccordionItem key={title}>
            <AccordionTitle icon={icon}>{t(title)}</AccordionTitle>
            <AccordionPanel hasIcon>
              <>
                <Typography variant="body2">{t(description)}</Typography>
                <Gutter size={2} />
              </>
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
